import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import InputFieldsComponent from '../../../components/common/InputFields';
import Button from '../../../components/common/Button';
import './OTPVerification.css';
import Time from '@pages/UserManagement/CreateNewUser/VerificationCard/time';
import Spinner from '@components/common/Spinner';
import InfoBar from '@components/common/InfoBars';

interface OtpcardcomponentProps {
    otpLabel: string;
    onOTPSubmit: (value: any) => void;
    otpLength: number;
    otpExpiryTime: number;
    otpRestartTimer: () => void;
    resetKey: number;
    showSpinner: boolean;
    showError: boolean;
    setShowError: any;
    errorMessage: string;
    retryMessage: string;
    retry: number;
    isTimeFinished: boolean;
    setIsTimeFinished: any;
}

const OTPComponent: React.FC<OtpcardcomponentProps> = ({
    otpLabel,
    onOTPSubmit,
    otpLength,
    otpExpiryTime,
    otpRestartTimer,
    resetKey = 0,
    showSpinner,
    showError,
    setShowError,
    errorMessage,
    retryMessage,
    retry,
    isTimeFinished,
    setIsTimeFinished

}) => {
    const [index, setIndex] = useState<number>(0);
    const [selectedInputFieldValue, setSelectedInputFieldValue] = useState<string[]>([]);
    const [onSubmit, setOnSubmit] = useState<boolean>(false);

    //Change header Accordingly and Checking input fields has values or not
    useEffect(() => {
        if (selectedInputFieldValue.length === otpLength && selectedInputFieldValue.every((str) => str !== '' && str !== null && str !== undefined)) {
            setOnSubmit(true);
        }
        else {
            setOnSubmit(false)
        }
    }, [selectedInputFieldValue]);

    //Handle Change for Input Field 
    const handleInputFieldChange = (value: string, index: number, event?: React.KeyboardEvent) => {
        setShowError(false);
        const newSelectedInputField = [...selectedInputFieldValue];
        if (event?.key === "Backspace") {
            if (!value) {
                if (index > 0) {
                    document.getElementById(`otp-input-${index - 1}`)?.focus();
                }
            } else {
                newSelectedInputField[index] = '';
                setSelectedInputFieldValue(newSelectedInputField);
            }
        }
        else if (value.trim()) {
            newSelectedInputField[index] = value.trim();
            setSelectedInputFieldValue(newSelectedInputField);
            setIndex(index + 1);
            const nextInput = document.getElementById(`otp-input-${index + 1}`);
            nextInput?.focus();
        }
        else {
            newSelectedInputField[index] = '';
            setSelectedInputFieldValue(newSelectedInputField);
            setIndex(index - 1);
        }
    }

    const onClickProceed = async () => {
        if (selectedInputFieldValue.length === 6) {
            const value = Number(selectedInputFieldValue.join(''));
            onOTPSubmit(value);
        }
    }

    const restartTimer = async () => {
        setSelectedInputFieldValue([]);
        otpRestartTimer();
    }
    const handleTimerEnd = () => {
        setIsTimeFinished(true);
    }
    const handleKeyDown = (event: React.KeyboardEvent, index: any) => {
        handleInputFieldChange(selectedInputFieldValue[index] || '', index, event);
    }
    return (
        <div className="otp_verification_card_main">
            <Card className="otp_verification_entire_card">
                <Card.Header className="otp_verification_card_header">
                    Enter OTP
                </Card.Header>
                <Card.Body className="otp_verification_card_body">
                    <label className="otp_verification_card_body_label">
                        {otpLabel}
                    </label>
                    <form autoComplete='off'>
                        <div className="otp_verification_card_body_container">
                            {Array.from({ length: otpLength }).map((_, index) => (
                                <div className="otp_verification_card_body_container_text" key={index}>
                                    <InputFieldsComponent
                                        className={
                                            selectedInputFieldValue[index]
                                                ? 'otp_verification_card_body_input_field_has_value'
                                                : 'otp_verification_card_body_input_field'
                                        }
                                        placeholder={'_'}
                                        inputType={'entered'}
                                        type={'number'}
                                        isDisabled={false}
                                        inputId={`otp-input-${index}`}
                                        onChange={(value: string) => handleInputFieldChange(value, index)}
                                        maximumLength={1}
                                        value={selectedInputFieldValue[index] || ''}
                                        onkeydown={(event:any) => handleKeyDown(event, index)}
                                    />
                                </div>
                            ))}
                        </div>
                        {showError && <InfoBar className="otp_verification_card_body_infobar" variant={'danger'} message={errorMessage} />}
                    </form>

                    <div className="otp_verification_card_body_resend">
                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                            <h2 style={{ fontSize: '14px' }}>Didn't receive an OTP</h2>
                            <span> {isTimeFinished ?
                                <Button
                                    onClick={restartTimer}
                                    disabled={false}
                                    id=""
                                    buttonName={'Resend OTP'}
                                    colorType={'save'}
                                    icon={''}
                                    iconPosition={''}
                                /> : <div className="otp_verification_card_body_button">
                                    <Button
                                        onClick={() => { }}
                                        disabled={true}
                                        id=""
                                        buttonName={`Resend OTP in`}
                                        colorType={'save'}
                                        icon={''}
                                        iconPosition={''}
                                    />
                                </div>
                            }</span>
                            <span><Time startTime={otpExpiryTime} resetKey={resetKey} onTImeEnd={handleTimerEnd} /></span>
                        </div>
                        <span className="no_of_retries_resend_otp">Retries left : {retry >= 0 ? retry : 0}</span>
                        <span className="no_of_retries_resend_otp">{retryMessage}</span>
                    </div>
                    <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
                </Card.Body>
                <Card.Footer className="otp_verification_card_footer">
                    <Button
                        buttonName={'Submit'}
                        colorType={onSubmit ? 'primary' : 'disabled'}
                        id={'otp_verification_button_submit'}
                        onClick={onClickProceed}
                        disabled={onSubmit ? false : true}
                    />
                </Card.Footer>
            </Card>
        </div>
    );
};

export default OTPComponent;
